/**
 * Frontend Environment Configuration
 * All environment variables are loaded at build time from .env files
 */

export const environment = {
  // API
  apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:3000',
  apiTimeout: parseInt(import.meta.env.VITE_API_TIMEOUT || '30000'),

  // App
  appName: import.meta.env.VITE_APP_NAME || 'BabyKingdom',
  appVersion: import.meta.env.VITE_APP_VERSION || '1.0.0',

  // Environment
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
  nodeEnv: import.meta.env.MODE || 'development',

  // Features
  enableAnalytics: import.meta.env.VITE_ENABLE_ANALYTICS === 'true',
  enableSentry: import.meta.env.VITE_ENABLE_SENTRY === 'true',
  sentryDsn: import.meta.env.VITE_SENTRY_DSN,

  // Social
  enableDiscordIntegration: import.meta.env.VITE_ENABLE_DISCORD === 'true',
  enableTwitchIntegration: import.meta.env.VITE_ENABLE_TWITCH === 'true',

  // Storage
  storagePrefix: import.meta.env.VITE_STORAGE_PREFIX || 'babykingdom',

  // WebSocket
  wsUrl: import.meta.env.VITE_WS_URL || 'http://localhost:3000',
} as const

export type Environment = typeof environment
